const ALL_FACILITIES_STATISTIC_VALUE = 'All';

export { ALL_FACILITIES_STATISTIC_VALUE };
